import useAuthStore from '@/stores/useAuthStore'
import { useDashboardQuickHelp } from '../../hooks/useDashboardQuickHelp'

// Import department-specific dashboards
import SalesDashboard from './SalesDashboard'
import AccountDashboard from './AccountDashboard'
import MarketingDashboard from './MarketingDashboard'
import FinanceDashboard from './FinanceDashboard'
import HRDashboard from './HRDashboard'
import TechDashboard from './TechDashboard'
import ExecutiveDashboard from './ExecutiveDashboard'
import GeneralDashboard from './GeneralDashboard'

// Department name to dashboard component mapping
const DEPARTMENT_DASHBOARDS: Record<string, React.FC> = {
    // Sales departments
    SALES: SalesDashboard,
    'SALE PARTNER': SalesDashboard,

    // Account department
    ACCOUNT: AccountDashboard,

    // Marketing department
    MARKETING: MarketingDashboard,

    // Finance department
    FINANCE: FinanceDashboard,

    // HR department
    'HUMAN RESOURCE': HRDashboard,

    // Tech departments
    TECHNOLOGY: TechDashboard,
    DEVELOPMENT: TechDashboard,

    // Executive/Management
    'BOARD OF DIRECTORS': ExecutiveDashboard,
    'BOARD OF MANAGEMENT': ExecutiveDashboard,
}

const DepartmentDashboard = () => {
    const employee = useAuthStore((state) => state.employee)
    const departmentName = employee?.department_name?.toUpperCase() || ''

    // Register Quick Help options for Dashboard
    useDashboardQuickHelp()

    // Get dashboard component based on department, fallback to GeneralDashboard
    const DashboardComponent =
        DEPARTMENT_DASHBOARDS[departmentName] || GeneralDashboard

    return <DashboardComponent />
}

export default DepartmentDashboard
